import moment from 'moment';

const Agreed = ({ title, data }) => (
    <div className="d-flex-1">
        <div className="d-flex ai-center">
            <p className="dsl-m12 title">{title}</p>
            <p className="dsl-b16">{data?.name}</p>
        </div>
        <div className="d-flex ai-center mb-3">
            <span className="dsl-m12 title">Date:</span>
            <span className="dsl-b16">{moment.utc(data?.time).local().format('MMM DD YY')}</span>
        </div>
        <div className="d-flex ai-center mb-3">
            <span className="dsl-m12 title">Time:</span>
            <span className="dsl-b16">{moment.utc(data?.time).local().format('hh: mm A')}</span>
        </div>
        <div className="d-flex ai-center">
            <span className="dsl-m12 title">IP:</span>
            <span className="dsl-b16">{data?.ip}</span>
        </div>
    </div>
);

export default Agreed;
